/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';

import OrganizerCard from '../../../cards/OrganizerCard';
import { comparator, ComparatorTypes } from '../../../../utils/comparator';
import { isClubAdminOrOwner, ClubTierTypes } from '../../../../utils/clubs';
import { setPlayerId } from '../../../../actions/profile-actions';
import { getClickAttrs } from '../../../Analytics/gtag';

import styles from '../../../../pages/ClubProfiles/club.scss';

const Organizers = (props) => {
    const {
        clubDetails,
        profile,
        auth,
    } = props;

    const clubType = props.clubType || 'clubs';

    const {
        clubOrganizers,
        canHaveMultipleAdmins,
        tierType,
        id,
    } = clubDetails;

    const organiserComparator = comparator({
        type: ComparatorTypes.NUMBER,
        field: 'clubMemberRoleId',
        descend: false,
    });

    const isPaidHit = tierType.id === ClubTierTypes.PAID_HIT;

    useEffect(() => {
        if (isPaidHit && clubDetails.clubOrganizers && !profile.isLoading && !profile.isProfileLoaded) {
            const headOrganizer = find(clubOrganizers, { role: 'Owner' });
            if (headOrganizer) {
                props.getPaidHitterProfile(headOrganizer.id);
            }
        }
    }, [clubOrganizers]);

    return (
        <div>
            {isPaidHit ? (
                <div>
                    <h6>About</h6>
                    <div className={`${styles.organisers}`}>
                        <OrganizerCard
                            key={`organizer`}
                            organizer={props.profile.data}
                            user={auth.user}
                            sendMessage={props.sendMessage}
                            className={'p24'}
                            paidHit={isPaidHit}
                        />
                    </div>
                </div>
            ) : (
                <React.Fragment>
                    {clubOrganizers && clubOrganizers.length > 0 && (
                        <React.Fragment>
                            <h6>Providers</h6>
                            <div className={`${styles.organisers}`}>
                                {clubOrganizers.sort(organiserComparator).map((clubOrganizer, i) => {
                                    return (
                                        <OrganizerCard
                                            key={`organizer-${i}`}
                                            organizer={clubOrganizer}
                                            user={auth.user}
                                            sendMessage={props.sendMessage}
                                        />
                                    );
                                })}
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
            {canHaveMultipleAdmins && isClubAdminOrOwner(clubDetails) && (
                <div className="mt8">
                    <a
                        href={`/${clubType}/${id}/organizers/add`}
                        className={`${styles.addOrganisers} underline`}
                        {...getClickAttrs({
                            category: 'Add Organizer',
                            context: '+ Add Providers button click',
                            location: 'Add organizer CTA',
                        })}
                    >
                        + Add Providers
                    </a>
                </div>
            )}
        </div>
    );
};

function mapStateToProps({ profile }) {
    return { profile };
}

function mapDispatchToProps(dispatch) {
    return {
        getPaidHitterProfile: (playerId) => dispatch(setPlayerId(playerId, false)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Organizers);
